import { Component, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { Events } from 'ionic-angular';
import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
@Component({
  selector: 'vertical-tab',
  templateUrl: 'vertical-tab.html',
})
export class VerticalTabComponent {

  paramData: any;
  codeData: { 'Code': any; 'accessType': any; 'templateName': any; };
  @Input() components: any;
  navTemplate: any;
  rootParams: any;
  componentRef: any;
  selectedTemplateProperty: any;
  showFormGridApplication: boolean = true;
  showNavTemplate: boolean = true;
  screenPropsVal: any;
  templateGroup: any[];
  templateSummaryGroup: any[];
  pullParams: any;
  formLayoutArr: any[];
  templateProps: any[];
  summaryDataArr: any;
  index: any = 0;
  sick: any = '';
  personal: any = '';
  vocation: any = '';
  formData: any;

  @Output() tabTemplateName = new EventEmitter();
  @Input() params: any;
  @Input() accessType: any;
  @Input() templateName: any;
  @Input() dataAccessType: any;
  @Input() screenProps: any;
  @Input() tabTemplates: any = [];
  @Input() containerComp: any;
  template: any;
  returnPushRequest: void;
  formObj: any = {};
  PushParamKeys: {};
  AccessuserCreateSucess: void;
  broadcastSubs: any;

  @Input() set multiSelectedTemplate(v: any) {
    this.tabTemplates = v;
  };
  selectedSegment: string;

  constructor(public communicationServ: CommunicationServiceProvider, public configApiService: ConfigApiServiceProvider, public events: Events, private storeWrap: StoreWrapProvider, private cdr: ChangeDetectorRef, public driveService: DriveServiceProvider, public EncrDecrServiceProvider: EncrDecrServiceProvider) {

  }


  ngOnInit() {
    this.initDriveEvents();

    // MOVE CUSTOM COMPONENT TO LIBRARY SCRIPTS
    this.events.subscribe('driveServiceMapFormtoPushData', (formData, templateProps) => {
      this.mapFormtoPushDataLib(formData, templateProps);
    })

    this.events.subscribe('drivePushRequest', (objdata) => {
      this.postLibRequest(objdata);
    })

    this.events.subscribe('fetchScreenProperties', ({ }, templateID, screenProps, gridRowData) => {
      this.libFetchScreenProperties(templateID, screenProps, gridRowData);
    })

    this.events.subscribe('accessGetSummaryData', (summaryPullParams, summaryResponse) => {
      this.accessGetSummaryData(summaryPullParams, summaryResponse);
    })

    this.events.subscribe('userPushParams', (status) => {
      if (status === true) {
        this.AccessgetPushparms();
      }
    })

    this.events.subscribe('getuserExtPushParams', (status) => {
      if (status === true) {
        this.userExtPushParams();
      }
    })

    this.events.subscribe('getScreeProperties', (status, params, lookupTemplateId) => {
      if (status === true) {
        this.getAcessScreeProperties(params, lookupTemplateId);
      }
    })

    this.events.subscribe('configApiServicepushSPRequest', (objData) => {
      this.configApiServicepushSPRequest(objData);
    })

    this.events.subscribe('configApiServicepushRequest', (objData) => {
      this.configApiServicepushRequest(objData);
    })

    /* * * * * * * * * *
     * pull app componets
     * * * * * * * * * */
    this.driveService.broadcastInfo({ src: 'defaultProps', event: 'pullAppComponents', status: true });
    this.selectedSegment = this.tabTemplates[0].templateName;
    let templateProperty = this.tabTemplates[0];
    // this.navTemplate = this.components[0].comp;
    this.rootParams = { selectedData: { 'screenProps': templateProperty, 'params': this.params, 'accessType': templateProperty.accessType, 'templateName': templateProperty.templateName } };
    this.openTabComponent(templateProperty, this.tabTemplates);
  }

  initDriveEvents() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "comp-main") {
          if (data.event === 'getAppComponents') {
            let flag = data['status'];
            let components = data['components']
            if (flag) {
              this.components = components;
            }
          }
        } else if (data.src === 'defaultProps') {
          if (data.event === 'pushParamsValue') {
            if (this.params) {
              this.params = data.params;
              this.dataAccessType = "editdata";
            }
          } else if (data.event === 'passParentScreenParamOnNew') {
            if (data.params) {
              this.params = data.params;
            }
          }
        } else if (data.src === 'header-detail') {
          if (data.event === 'pushHeaderParamsValue') {
            if (this.params) {
              this.params = data.params;
              this.dataAccessType = "editdata";
            }
          } else if (data.event === 'pushHeaderLink') {
            if (this.params) {
              this.params = data.params;
              this.dataAccessType = "editdata";
              this.openTabComponent(this.selectedTemplateProperty, this.tabTemplates);
            }
          }
        }
      })

  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  onSelectTab(e, selectedTab) {
    this.templateName = selectedTab.templateName;
    this.paramData = this.params;
    this.rootParams = this.rootParams;
  }

  openTabComponent(templateProperty, templates) {
    this.templateName = templateProperty.templateName;
    this.selectedTemplateProperty = templateProperty;
    this.paramData = this.params;
    this.rootParams = this.rootParams;
    let parentScreenParam = {};

    ///@SANTHIYA IF ELSE IF CONDITION ADDED TO FIND THE SOURCEKEY IS SAME OR NOT
    let componentHolderName: any = '';
    let objEnableTrack: any = '';

    objEnableTrack = this.driveService.objCurrentFolder['objEnableTrack'];
    if (objEnableTrack) {
      objEnableTrack = JSON.parse(objEnableTrack);
      componentHolderName = objEnableTrack['componentHolderName'];
    }
    if (componentHolderName) {
      if (this.params[this.rootParams.selectedData.screenProps.sourceKey] != undefined) {
        parentScreenParam[this.rootParams.selectedData.screenProps.sourceKey] = this.params[this.rootParams.selectedData.screenProps.sourceKey];
      } else {
        parentScreenParam[this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey] = this.params[Object.keys(this.params)[0]];
      }

    } else {
      if (this.driveService.objCurrentFolder.template.findIndex(element => element.id == this.rootParams.selectedData.screenProps.id) > 0) {
        let sourceKey = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey
        parentScreenParam = { [sourceKey]: this.params[sourceKey] };
      } else {
        parentScreenParam[this.rootParams.selectedData.screenProps.sourceKey] = this.params[this.rootParams.selectedData.screenProps.sourceKey];
      }
    }
    
    if(templateProperty.componentName == 'FormGridComponent'){
      this.driveService.formGridTempProps['screenProps'] = this.driveService.storeWrap.storeTemplates[templateProperty.id];
      this.driveService.formGridTempProps['parentScreenParam'] = parentScreenParam;
    }

    let component = this.getComponent(templateProperty.componentName);
    if (templateProperty.componentName != 'FormGridComponent' && templateProperty.componentName != 'SEARCHGRID') {
      this.events.publish('tabTrigger', true);
    } else {
      this.events.publish('tabTrigger', true);
    }

    if (!component) {
      component = this.components[0];
      this.navTemplate = component['comp'];
      this.driveService.fetchScreenProperties(parentScreenParam, templateProperty.id, (screenProps, gridRowData = null) => {
        this.events.publish('tabTriggerData', true, screenProps, parentScreenParam, this.dataAccessType, this.templateGroup, gridRowData);
      });
    } else {
      this.navTemplate = component['comp'];
      let componentName = this.getComponent(templateProperty.id);
      if (templateProperty.componentName != 'FormGridComponent' && templateProperty.componentName != 'SUMMARY' && templateProperty.componentName != 'SEARCHGRID') {
        this.formLayoutArr = [];
        this.templateProps = [];
        this.index = 0;
        let screenProps = this.driveService.storeWrap.storeTemplates[templateProperty.id];
        this.templateGroup = this.getTemplateGroup(screenProps);
        this.pullParams = this.getPullParams(screenProps, parentScreenParam);
        if (this.pullParams.PushArray.length > 0) {
          this.configApiService.pullSummaryListRequest(this.pullParams, (summaryResponse) => {
            this.summaryDataArr = summaryResponse;
            this.getFormLayout(parentScreenParam, (formLayoutArr) => {
              this.driveService.setMutiTemplateFormData(this.formLayoutArr, (formObj) => {
                this.driveService.getFormFieldsData(this.formLayoutArr, (formFields) => {
                  var multiTemplateProps = Object.assign({}, { "templateGroup": this.templateGroup, "templateSummaryGroup": this.templateSummaryGroup, "pullParams": this.pullParams, "summaryDataArr": this.summaryDataArr, "formLayoutArr": this.formLayoutArr, "templateProps": this.templateProps, "formObj": formObj, "formFields": formFields });
                  if (this.templateGroup.length > 1) {
                    this.sendParamsToLib();
                    this.events.publish('tabTriggerDataToCustomApplication', true, screenProps, parentScreenParam, this.dataAccessType, multiTemplateProps);
                  } else {
                    setTimeout(() => {
                      this.sendParamsToLib();
                      this.events.publish('tabTriggerDataToCustomAccessApplication', true, screenProps, parentScreenParam, this.dataAccessType, multiTemplateProps);

                    }, 1000);
                  }
                });
              });
            });
          });
        } else {
          this.driveService.fetchScreenProperties(parentScreenParam, templateProperty.id, (screenProps, gridRowData = null) => {
            this.events.publish('tabTriggerData', true, screenProps, parentScreenParam, this.dataAccessType, this.templateGroup);
          });
        }
      } else {
        if (templateProperty.componentName != 'FormGridComponent' && templateProperty.componentName != 'SEARCHGRID') {
          this.driveService.fetchScreenProperties(parentScreenParam, templateProperty.id, (screenProps, gridRowData = null) => {
            setTimeout(() => {
              let rowDataStatus = true;
              this.driveService.broadcastInfo({ src: 'form-grid', event: 'tabTriggerDataToGridApplication', status: true, componentName: componentName, screenProps: screenProps, parentScreenParam: parentScreenParam, accessType: this.accessType, dataAccessType: this.dataAccessType, components: this.components, gridRowData: gridRowData, rowDataStatus: rowDataStatus });
            }, 200);
          });

        } else {
          this.driveService.fetchScreenProperties(parentScreenParam, templateProperty.id, (screenProps, gridRowData = null) => {
            setTimeout(() => {
              if (gridRowData != null) {
                this.driveService.CurrentFilesData = gridRowData;
              }
              let rowDataStatus = true;
              this.driveService.broadcastInfo({ src: 'form-grid', event: 'tabTriggerDataToGridApplication', status: true, componentName: componentName, screenProps: screenProps, parentScreenParam: parentScreenParam, accessType: this.accessType, dataAccessType: this.dataAccessType, components: this.components, gridRowData: gridRowData, rowDataStatus: rowDataStatus });
            }, 200);
          });
        }

      }
    }

  }

  /* * * * * *
  * get FormLayout properties for multiple template
  * * * * * */
  startFetchLayout(parentScreenParam, cbck) {
    let templateID = this.templateGroup[this.index]
    var rowData = this.summaryDataArr[this.index];
    if (rowData.length > 0) {
      rowData = rowData[0];
    } else {
      rowData = {};
    }
    this.driveService.fetchTemplateProperties(parentScreenParam, rowData, templateID, (templatePops) => {
      this.templateProps.push(templatePops);
      this.formLayoutArr.push(templatePops['formLayout']);
      this.index++;
      this.getFormLayout(parentScreenParam, cbck);
    });
  }
  /* * * * * *
  * get FormLayout properties for multiple template
  * * * * * */
  getFormLayout(parentScreenParam, cbck) {
    let len = this.templateGroup.length - 1;
    if (this.index > len) {
      cbck(this.formLayoutArr);
    } else {
      this.startFetchLayout(parentScreenParam, cbck)
    }
  }

  /* * * * * *
  * get template data
  * * * * * */
  getPullParams(screenProps, parentScreenParam) {
    var templatePops;
    this.pullParams = Object.assign({}, screenProps.fieldParams, { "PushArray": [] });
    this.templateGroup.forEach((templateID) => {
      templatePops = this.driveService.storeWrap.storeTemplates[templateID];
      var obj = {};
      if (templateID === 'main_empcommunicationdetails600') {
        obj = Object.assign({}, templatePops.pullParams, parentScreenParam, { "addresstype": 6, "apiType": "Summary" });
      } else {
        obj = Object.assign({}, templatePops.pullParams, parentScreenParam, { "apiType": "Summary" });
      }
      this.pullParams['PushArray'].push(obj);
    });
    return this.pullParams;
  }

  /* * * * * *
  * get template group data
  * * * * * */
  getTemplateGroup(template) {
    this.templateGroup = [];
    if (template['pluginData']) {
      let pluginData = JSON.parse(template['pluginData'])
      if (pluginData['templateGroup']) {
        this.templateGroup = pluginData['templateGroup'];
      } if (pluginData['templateSummaryGroup']) {
        this.templateSummaryGroup = pluginData['templateSummaryGroup'];
      }
    }
    return this.templateGroup;
  }

  /* * * * * *
  * get component
  * * * * * */
  getComponent(name) {
    for (let i = 0; i < this.components.length; i++) {
      let item = this.components[i];
      if (item.compName === name) {
        return item;
      }
    };
    return null;
  }

  // MOVE CUSTOM COMPONENT TO LIBRARY SCRIPTS
  sendParamsToLib() {
    this.template = this.driveService.storeWrap.storeTemplates;
    this.events.publish('templatePassingAccessLibrary', true, this.template);
    this.events.publish('templatePassingLibrary', true, this.template);
    this.events.publish('driveObjCurrentParentFolder', this.driveService.objCurrentParentFolder);
    this.driveService.broadcastInfo({ src: 'comp-main', event: 'getAppComponents', status: true, components: this.components });
  }

  mapFormtoPushDataLib(formData, templateProps) {
    let mapFormData = this.driveService.mapFormtoPushData(formData, templateProps);
    this.events.publish("returnMapFormData", true, mapFormData);
  }

  postLibRequest(objData) {
    var status;
    this.configApiService.pushRequest(objData, (respData) => {
      if (respData == 'FAIL' || respData == 'FAILED') {
        status = this.configApiService.respMessage;
      } else {
        status = 'SUCCESS';
      }
      this.events.publish("returnDrivePushRequest", status, respData);
    });
  }

  libFetchScreenProperties(templateID, screenProps, gridRowData) {
    this.driveService.fetchScreenProperties({}, templateID, (screenProps, gridRowData = null) => {
      this.events.publish('returnFetchScreenProperties', true, screenProps)
    });
  }

  accessGetSummaryData(summaryPullParams: any, summaryResponse: any) {
    let _formObj = {};
    let personal, sick, vocation;
    this.configApiService.pullSummaryListRequest(summaryPullParams, (summaryResponse) => {
      Object.keys(summaryResponse).forEach(function (index) {
        var _obj;
        if (summaryResponse[index].length > 0) {
          _obj = summaryResponse[index][0];
          _formObj = Object.assign({}, _formObj, _obj);
        }
      });
      Object.keys(summaryResponse[4]).forEach(function (index) {
        let data = summaryResponse[4][index];
        Object.keys(data).forEach(function (dataKey) {
          if (data[dataKey] == 'Personal') {
            personal = data['available'];
          } else if (data[dataKey] == 'Sick') {
            sick = data['available'];
          } else if (data[dataKey] == 'Vacation') {
            vocation = data['available'];
          }
        })
      });
      this.personal = personal;
      this.sick = sick;
      this.vocation = vocation;
      this.formObj = _formObj;
      this.events.publish('ReturnAccessGetSummaryData', true, this.personal, this.sick, this.vocation, this.formObj)
    })

  }

  AccessgetPushparms() {
    const pushParams = this.configApiService.driveApi.starportAddUser.params;
    this.PushParamKeys = this.driveService.getPushParamKeys(pushParams);
    this.events.publish('AccessgetPushparms', true, this.PushParamKeys, pushParams);
  }

  userExtPushParams() {
    const pushParams = this.configApiService.driveApi.starportAddUserExt.params;
    this.PushParamKeys = this.driveService.getPushParamKeys(pushParams);
    this.events.publish('userExtPushParams', true, this.PushParamKeys, pushParams);
  }

  getAcessScreeProperties(params, lookupTemplateId) {
    this.driveService.fetchScreenProperties(params, lookupTemplateId, (screenProps) => {
      screenProps.formLayout[0][0].fields.forEach((field) => {
        if (field.FieldName == 'TeamId') {
          if (field.options) {
            let teamOptions = field.options;
            this.events.publish('teamOptions', true, teamOptions);
          }
        }
      });
    })
  }

  configApiServicepushSPRequest(objData) {
    var status;
    this.configApiService.pushRequest(objData, (respData) => {
      if (respData == 'FAIL' || respData == 'FAILED') {
        status = this.configApiService.respMessage;
      } else {
        status = 'SUCCESS';
      }
      this.events.publish("ResturnConfigApiServicepushSPRequest", status, respData);
    });
  }

  configApiServicepushRequest(objData) {
    var status;
    this.configApiService.pushRequest(objData, (respData) => {
      if (respData == 'FAIL' || respData == 'FAILED') {
        status = this.configApiService.respMessage;
      } else {
        status = 'SUCCESS';
      }
      this.events.publish("ResturnconfigApiServicepushRequest", status, respData);
    });
  }

  ngOnDestroy() {
    this.events.unsubscribe('driveServiceMapFormtoPushData');
    this.events.unsubscribe('drivePushRequest');
    this.events.unsubscribe('accessGetSummaryData');
    this.events.unsubscribe('configApiServicepushSPRequest');
    this.events.unsubscribe('configApiServicepushRequest');
    this.events.unsubscribe('getuserExtPushParams');
    this.events.unsubscribe('getScreeProperties');
  }

}



// WEBPACK FOOTER //
// ./src/components/vertical-tab/vertical-tab.ts